import React from "react";
import "../static/css/LoadingSpinner.css";

const LoadingSpinner = ({
  size = "medium",
  color = "#007bff",
  text = "Loading...",
  overlay = false,
  className = ""
}) => {
  const sizeClasses = {
    small: "loading-spinner--small",
    medium: "loading-spinner--medium",
    large: "loading-spinner--large"
  };

  const spinnerClass =
    `loading-spinner ${sizeClasses[size]} ${className}`.trim();

  const spinnerElement = (
    <div className={spinnerClass}>
      <div
        className="loading-spinner__circle"
        style={{ borderTopColor: color }}
      ></div>
      {text && <div className="loading-spinner__text">{text}</div>}
    </div>
  );

  if (overlay) {
    return <div className="loading-spinner-overlay">{spinnerElement}</div>;
  }

  return spinnerElement;
};

export default LoadingSpinner;
